import { SWRConfiguration } from 'swr';

import { UseSWROutput, useSWR } from '~/hooks/useSWR';
import { BenefitProposalsReadApiClient } from '~/services/Http';

import {
  BenefitDto,
  Order6,
  WorkflowStatuses2,
} from '../../client.rewarding.generated';

export const GET_Benefit_PROPOSALS_SWR_KEY =
  'BenefitProposalsReadApiClient.getAllProposals';

export function useGetBenefitProposals(
  args?: {
    order?: Order6;
    offset?: number;
    limit?: number;
    startDate?: Date;
    endDate?: Date;
    lang?: string;
    includeHistory?: boolean;
    uids?: string[];
    employeeIds?: number[];
    unitIds?: number[];
    roles?: string[];
    workflowStatuses?: WorkflowStatuses2[];
    workflowHandlers?: number[];
    sort?: string[];
  },
  swrConfig?: SWRConfiguration<BenefitDto[]>,
  disable?: boolean,
): UseSWROutput<BenefitDto[]> {
  return useSWR(
    !disable
      ? [
          GET_Benefit_PROPOSALS_SWR_KEY,
          args?.order ?? undefined,
          args?.offset ?? undefined,
          args?.limit ?? undefined,
          args?.startDate ?? undefined,
          args?.endDate ?? undefined,
          args?.lang ?? undefined,
          args?.includeHistory ?? undefined,
          args?.uids ?? undefined,
          args?.employeeIds ?? undefined,
          args?.unitIds ?? undefined,
          args?.roles ?? undefined,
          args?.workflowStatuses ?? undefined,
          args?.workflowHandlers ?? undefined,
          args?.sort ?? undefined,
        ]
      : null,
    ([
      _,
      order,
      offset,
      limit,
      startDate,
      endDate,
      lang,
      includeHistory,
      uids,
      employeeIds,
      unitIds,
      roles,
      workflowStatuses,
      workflowHandlers,
      sort,
    ]) =>
      BenefitProposalsReadApiClient.getAllProposals(
        order,
        offset,
        limit,
        startDate,
        endDate,
        lang,
        includeHistory,
        uids,
        employeeIds,
        unitIds,
        roles,
        workflowStatuses,
        workflowHandlers,
        sort,
      ).then((r) => r.data),
    swrConfig,
  );
}
